<ng-template #infosTemplateHeader>
  <a routerLink="informations">Voir toutes les informations</a>
</ng-template>
<ng-template #infosTemplateContent>
  @for (desc of infos; track desc) {
    <a
      class="content-grid p-3 cursor-pointer"
      [class.direct]="desc.info.type === 'DIRECT'"
      routerLink="informations">
      @if (desc.info.type === 'DIRECT' && desc.showIcon) {
        <fa-icon icon="bell"
        class="d-none d-md-inline-block text-danger" size="lg"></fa-icon>
      }
      @if (desc.info.type === 'PINNED' && desc.showIcon) {
        <fa-icon icon="thumbtack"
        class="d-none d-md-inline-block  text-info" size="lg"></fa-icon>
      }
      @if ((desc.info.type !== 'DIRECT' && desc.info.type !== 'PINNED') || !desc.showIcon) {
        <span></span>
      }
      <div>
        <div>{{ desc.info.title }}</div>
        <div class="fst-italic text-light-grey">Publiée le {{ desc.info.publication | date:'dd/MM/yyyy à HH' }}
          h{{ desc.info.publication | date:'mm' }}
        </div>
      </div>
      <div class="justify-self-end">
        @for (label of desc.info.labels; track label) {
          <app-badge [label]="label"></app-badge>
        }
      </div>
    </a>
  }
  @if (infos.length === 0) {
    <div class="ps-3 pe-3 pt-4 pb-4">
      <div class="text-info">
        <fa-icon icon="info-circle"></fa-icon>
        Aucune information en direct ce jour.
      </div>
    </div>
  }
</ng-template>
<app-dash-block title="Informations à la une" [headerTemplate]="infosTemplateHeader"
  [contentTemplate]="infos ? infosTemplateContent : null">
</app-dash-block>
